import PixelBody from './PixelBody';

export default PixelBody;
